// React and Router imports
import { useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

// Icon imports
import { FaRegUser, FaRegUserCircle } from 'react-icons/fa'
import { AiOutlineLogout } from 'react-icons/ai'

// Utils and Store imports
import { removeToken } from '../../utils/cookies/cookies'
import useUserStore from '../../utils/state/useUserStore'

// Components
import CustomToast from '../Custom/CustomToast'

const DropdownUser = () => {
  // Hooks
  const removeUser = useUserStore((state) => state.removeUser)
  const navigate = useNavigate()

  // Refs for click outside handling
  const trigger = useRef(null)
  const dropdown = useRef(null)

  // State
  const [dropdownOpen, setDropdownOpen] = useState(false)

  // Handle click outside dropdown
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!dropdown.current) return
      if (
        !dropdownOpen ||
        dropdown.current.contains(target) ||
        trigger.current.contains(target)
      )
        return
      setDropdownOpen(false)
    }
    document.addEventListener('click', clickHandler)
    return () => document.removeEventListener('click', clickHandler)
  }, [dropdownOpen])

  // Handle escape key press
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!dropdownOpen || keyCode !== 27) return
      setDropdownOpen(false)
    }
    document.addEventListener('keydown', keyHandler)
    return () => document.removeEventListener('keydown', keyHandler)
  }, [dropdownOpen])

  // Handle user logout
  const handleLogout = async () => {
    try {
      removeUser()
      removeToken()
      CustomToast({
        message: 'Logout successfully.',
        type: 'success',
      })
      navigate('/login')
    } catch (error) {
      CustomToast({
        message: 'Logout failed. Please try again.',
        type: 'error',
      })
    }
  }

  return (
    <div className='relative'>
      <button
        ref={trigger}
        onClick={() => setDropdownOpen(!dropdownOpen)}
        className='h-10 w-10 flex justify-center items-center rounded-full bg-prime text-white text-xl'
        aria-label='Toggle user menu'
      >
        <FaRegUserCircle />
      </button>

      <div
        ref={dropdown}
        role='menu'
        aria-orientation='vertical'
        aria-labelledby='user-menu'
        className={`absolute right-0 flex w-60 flex-col mt-2 rounded-md border shadow-lg overflow-hidden bg-white ${
          dropdownOpen ? 'block' : 'hidden'
        }`}
      >
        <ul className='flex flex-col dropDown-list font-semibold'>
          <li>
            <Link
              to='/profile'
              className='flex items-center gap-2 text-sm duration-300 ease-in-out py-3 px-5 hover:text-white hover:bg-prime'
              role='menuitem'
            >
              <FaRegUser className='text-xl' />
              My Profile
            </Link>
          </li>
          <li>
            <button
              onClick={handleLogout}
              className='w-full flex items-center gap-2 text-sm duration-300 ease-in-out py-3 px-5 hover:text-white hover:bg-prime'
              role='menuitem'
            >
              <AiOutlineLogout className='text-xl' />
              Logout
            </button>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default DropdownUser
